const INSURANCE_YEARS_OLD_LIMIT = 65

export { INSURANCE_YEARS_OLD_LIMIT }
